module.exports = __webpack_public_path__ + "fe6abc2c579667bf7969cd0aaaae30f7.MP3";